export const NAME = 'Name'
export const TEACHES_LESSONS = 'Lesson Instructor'
export const EXPERIENCE = 'Experience'
export const ELEMENTARY_COMPLETION = 'Elementary Completion'
export const MIDDLE_SCHOOL_COMPLETION = 'Middle School Completion'
export const TOTAL_ELEM_TRAININGS = 3
export const TOTAL_MS_TRAININGS = 4
